import { defineComponent as _defineComponent } from 'vue'
import { Icon } from '@iconify/vue2'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyState',
  props: {
    title: null,
    subtitle: null,
    clearable: { type: Boolean },
    icon: { default: 'fa6-solid:folder-open' },
    clearText: { default: 'Limpar pesquisa' }
  },
  emits: ["clear"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'clear'): void
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, Icon }
}

})